const APP_VERSION = '1783719246483';
export default APP_VERSION;
